import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function PromoBanners() {
  return <section className="py-8" aria-label="Promotional banners" data-id="element-233">
      <div className="max-w-7xl mx-auto px-4" data-id="element-234">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-235">
          {/* Banner 1 */}
          <Link to="/products?category=earbuds" className="relative overflow-hidden rounded-xl bg-gradient-to-r from-purple-600 to-purple-800 p-6 h-48 flex flex-col justify-end group" data-id="element-236">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-237" />
            <div className="relative z-10" data-id="element-238">
              <p className="text-purple-200 text-sm mb-1" data-id="element-239">Up to 50% Off</p>
              <h3 className="text-white text-xl font-bold mb-2" data-id="element-240">
                Wireless Earbuds
              </h3>
              <span className="inline-flex items-center gap-1 text-white text-sm font-medium group-hover:gap-2 transition-all" data-id="element-241">
                Shop Now <ArrowRightIcon className="w-4 h-4" data-id="element-242" />
              </span>
            </div>
          </Link>

          {/* Banner 2 */}
          <Link to="/products?category=smart-watches" className="relative overflow-hidden rounded-xl bg-gradient-to-r from-blue-600 to-blue-800 p-6 h-48 flex flex-col justify-end group" data-id="element-243">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-244" />
            <div className="relative z-10" data-id="element-245">
              <p className="text-blue-200 text-sm mb-1" data-id="element-246">New Collection</p>
              <h3 className="text-white text-xl font-bold mb-2" data-id="element-247">
                Smart Watches
              </h3>
              <span className="inline-flex items-center gap-1 text-white text-sm font-medium group-hover:gap-2 transition-all" data-id="element-248">
                Explore <ArrowRightIcon className="w-4 h-4" data-id="element-249" />
              </span>
            </div>
          </Link>

          {/* Banner 3 */}
          <Link to="/products?category=gaming-accessories" className="relative overflow-hidden rounded-xl bg-gradient-to-r from-green-600 to-green-800 p-6 h-48 flex flex-col justify-end group md:col-span-2 lg:col-span-1" data-id="element-250">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-251" />
            <div className="relative z-10" data-id="element-252">
              <p className="text-green-200 text-sm mb-1" data-id="element-253">Gamers Choice</p>
              <h3 className="text-white text-xl font-bold mb-2" data-id="element-254">Gaming Gear</h3>
              <span className="inline-flex items-center gap-1 text-white text-sm font-medium group-hover:gap-2 transition-all" data-id="element-255">
                Level Up <ArrowRightIcon className="w-4 h-4" data-id="element-256" />
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>;
}